import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
const _excluded = ["children", "value", "index", "unmountOnChangeTab"];
function CustomTabPanel(props) {
  const {
      children,
      value,
      index,
      unmountOnChangeTab
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    "aria-labelledby": "simple-tab-".concat(index)
  }, other), (!unmountOnChangeTab || value === index) && /*#__PURE__*/React.createElement(Box, null, children));
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  unmountOnChangeTab: PropTypes.bool
};
CustomTabPanel.defaultProps = {
  children: null,
  unmountOnChangeTab: true
};
export { CustomTabPanel as default };